var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "sortableList", staticClass: "draggable-list" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.displayDragArea
        ? _c("div", { staticClass: "drag-area", style: _vm.styleDragArea })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }